module.exports = __webpack_public_path__ + "img/wma.44991487.png";